import React from 'react'

export const withDefaultProps = <P,>(
  Component: React.ComponentType<P>,
  partialProps: Partial<P>
) => {
  return (props: P) => {
    return <Component {...partialProps} {...props} />
  }
}
